import { useContext } from 'react';
import clsx from 'clsx';

import { Icon } from '@atom/mui';
import { formTemplateContainsModule } from '@atom/selectors/formModuleSelectors';
import { FormModuleKeys, FormModuleType } from '@atom/types/form';

import FormBuilderContext from '../FormBuilderContext';

import classes from '../formBuilder.module.css';

interface Props {
  formModule: FormModuleType;
  selectedModule: string;
  selectModule: (data: string) => void;
  disabled?: boolean;
  displayOnly?: boolean;
}

const FormModuleTile = ({
  formModule,
  selectedModule,
  selectModule,
  disabled,
  displayOnly,
}: Props) => {
  const { formTemplate } = useContext(FormBuilderContext);

  const isAdded = formTemplateContainsModule(formModule.type, formTemplate);

  const isSelected = selectedModule === formModule.type;
  const isDisabledStyle = disabled || displayOnly;
  const showNextIcon =
    !isAdded && formModule.type === FormModuleKeys.CI && !displayOnly;

  const onClick = () => {
    return disabled || displayOnly ? {} : selectModule(formModule.type);
  };

  return (
    <div
      className={clsx(
        classes.formModuleItem,
        isSelected && classes.selected,
        isDisabledStyle && classes.disabled,
      )}
      onClick={onClick}
    >
      {formModule.icon}
      <div className={classes.formModuleInfo}>
        <div>
          <div
            className={clsx(
              classes.formModuleModalTitle,
              disabled && classes.disabled,
            )}
          >
            {formModule.title}
          </div>
          <div
            className={clsx(
              classes.formModuleDescription,
              disabled && classes.disabled,
            )}
          >
            {formModule.description}
          </div>
        </div>
        {isAdded && <div className={classes.formModuleAdded}>Added</div>}
        {showNextIcon && <Icon>navigate_next</Icon>}
      </div>
    </div>
  );
};

export default FormModuleTile;
